import React from "react";

const cars = [
  {
    img: "Dzire.jpg",
    name: "Swift Dzire",
    type: "Sedan",
    price: "₹12/km",
    oldPrice: "₹14/km",
    capacity: "4 Seater",
    luggage: "2 Bags",
  },
  {
    img: "ertiga.jpg",
    name: "Maruti Ertiga",
    type: "SUV",
    price: "₹15/km",
    oldPrice: "₹18/km",
    capacity: "6 Seater",
    luggage: "3 Bags",
  },
  {
    img: "rumion.jpg",
    name: "Toyota Rumion",
    type: "MUV",
    price: "₹15/km",
    oldPrice: "₹19/km",
    capacity: "6 Seater",
    luggage: "3 Bags",
  },
  {
    img: "kia.jpg",
    name: "Kia Carens",
    type: "Luxury MUV",
    price: "₹16/km",
    oldPrice: "₹20/km",
    capacity: "6/7 Seater",
    luggage: "3 Bags",
  },
  {
    img: "innova.jpg",
    name: "Innova Cab",
    type: "SUV",
    price: "₹17/km",
    oldPrice: "₹22/km",
    capacity: "7 Seater",
    luggage: "4 Bags",
  },
  {
    img: "innova-crysta.jpg",
    name: "Innova Crysta",
    type: "Premium SUV",
    price: "₹20/km",
    oldPrice: "₹24/km",
    capacity: "7 Seater",
    luggage: "4 Bags",
  },

];

const FleetSection = () => {
  return (
    <section className="tour-section fix section-padding">
      <div className="container">
        
        {/* Section Title */}
        <div className="section-title text-center">
          <span className="wow fadeInUp">Royal Route Cab Fleet</span>
          <h2 className="wow fadeInUp" data-wow-delay=".3s">
            Choose Your Perfect Ride
          </h2>
          <p className="mt-3 wow fadeInUp" data-wow-delay=".5s">
            Explore our wide range of well-maintained cars for local, outstation,
            airport, and corporate travel services.
          </p>
        </div>

        {/* Cars Grid */}
        <div className="row">
          {cars.map((car, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={`.${2 + index * 2}s`}
            >
              <div className="tour-box-items borderrr">
                
                {/* Image */}
                <div className="thumb">
                  <img
                    src={`/images/fleets/${car.img}`}
                    alt={car.name}
                  />
                </div>

                {/* Content */}
                <div className="content ">
                  <span>{car.type}</span>

                  <h4>
                    <a href="#">{car.name}</a>
                  </h4>

                  <h6>
                    Starting <span>{car.price}</span>{" "}
                    <del>{car.oldPrice}</del>
                  </h6>

                  <ul className="list">
                    <li>
                      <i className="far fa-user"></i>
                      {car.capacity}
                    </li>
                    <li>
                      <i className="fas fa-suitcase"></i>
                      {car.luggage}
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FleetSection;